import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgFacebook({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.347 21v-8.198h2.665l.397-3.21h-3.062V7.55c0-.927.25-1.56 1.53-1.56H16.5V3.127A21.2 21.2 0 0014.122 3c-2.356 0-3.974 1.493-3.974 4.231v2.356H7.5v3.21h2.654V21h3.193z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFacebook
